(() => {
  const prepared = new WeakSet();

  const prepareCard = (card, index = 0) => {
    if (!(card instanceof Element)) return;
    const images = card.querySelectorAll('img');
    images.forEach((image, imageIndex) => {
      if (prepared.has(image)) return;
      prepared.add(image);

      image.style.opacity = '1';
      image.style.visibility = 'visible';
      image.style.objectFit = 'contain';

      // Desktop browsers occasionally postpone card images too aggressively.
      // Eager-load only the lead image; secondary carousel images stay lazy.
      if (imageIndex === 0 && window.matchMedia('(min-width: 750px)').matches) {
        image.loading = 'eager';
        image.removeAttribute('loading');
        image.decoding = 'async';
        if (index < 4) image.fetchPriority = 'high';
      }

      const reveal = () => {
        image.classList.remove('legacy-image-loading');
        image.classList.add('legacy-image-loaded');
        image.style.opacity = '1';
        image.style.visibility = 'visible';
      };

      if (image.complete && image.naturalWidth > 0) reveal();
      else image.addEventListener('load', reveal, { once: true });
    });
  };

  const scan = (root = document) => {
    root.querySelectorAll?.('product-card').forEach((card, index) => prepareCard(card, index));
  };

  const boot = () => {
    scan();
    const observer = new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('product-card')) prepareCard(node);
        scan(node);
      }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
